export var HOOK = "data-shape-id";
export var radiansToDegrees = function (radians) {
    if (radians === void 0) { radians = 0; }
    var degrees = radians * (180 / Math.PI);
    return degrees > 180 ? degrees - 360 : degrees;
};
export var degreesToRadians = function (degrees) {
    if (degrees === void 0) { degrees = 0; }
    return ((degrees % 360) * Math.PI) / 180;
};
export var reverseDegrees = function (degrees) { return 360 - degrees; };
export var getElementHookValue = function (id, idPostfix) {
    if (idPostfix === void 0) { idPostfix = ''; }
    var postfix = idPostfix ? "-".concat(idPostfix) : '';
    return "".concat(id).concat(postfix);
};
export var getElementQuery = function (id, idPostfix) {
    var attributeValue = getElementHookValue(id, idPostfix);
    return "[".concat(HOOK, "=\"").concat(attributeValue, "\"]");
};
export var round = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.round(value / precision) * precision;
};
export var floor = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.floor(value / precision) * precision;
};
export var ceil = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.ceil(value / precision) * precision;
};
export var getElement = function (id, svgContainer, idPostfix) {
    var existentElement = svgContainer.querySelector(getElementQuery(id, idPostfix));
    if (existentElement) {
        return existentElement;
    }
    return null;
};
export var getSvgSrc = function (svgElement, sourceFormatter) {
    if (sourceFormatter === void 0) { sourceFormatter = function (source) { return source; }; }
    if (!svgElement) {
        return null;
    }
    else {
        return 'data:image/svg+xml,' + encodeURIComponent(sourceFormatter(svgElement.innerHTML));
    }
};
export var unique = function (values) { return Array.from(new Set(values)); };
//# sourceMappingURL=utils.js.map